import { render, staticRenderFns } from "./CostItem.vue?vue&type=template&id=5e2c089a&scoped=true&"
import script from "./CostItem.vue?vue&type=script&lang=js&"
export * from "./CostItem.vue?vue&type=script&lang=js&"
import style0 from "./CostItem.vue?vue&type=style&index=0&id=5e2c089a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c089a",
  null
  
)

export default component.exports